<div *ngIf="attributions && attributions.length > 0" class="wrapper mt-4">
    <div class="container">
        <div class="row-auto">
            <h4 class="selenium-attributions-header" style="margin: 20px 0">
                Made Possible Through
            </h4>
        </div>
        <div class="mb-4">
            <app-attributes [attributions]="attributions"></app-attributes>
        </div>
    </div>
</div>
